import validations from '../utils/validations';

export default class Form {
    constructor(data, options = { isEventForm: false, isCoreForm: false }) {
        this.originalData = data;
        this.setFormData(data);
        this.validationRules = this.getValidationRules(data);
        this.isProcessing = false;
        this.errors = {};
        this.axios = this.resolveClient(options);
    }

    /**
     * Which backend this form posts to. `isCoreForm` targets mha-usa-core,
     * which serves the flows migrated off this app's Dingo API.
     */
    resolveClient(options) {
        if (options.isCoreForm) return coreApiClient;

        return options.isEventForm ? eventHttpClient : axios;
    }

    setFormData(data) {
        Object.keys(data).forEach(field => {
            this[field] = data[field];
        });

        return this;
    }

    getValidationRules(data) {
        const rules = {};

        Object.keys(data).forEach(field => {
            rules[field] = validations[field];
        });

        return rules;
    }

    getFormData() {
        const data = {};

        Object.keys(this.originalData).forEach(field => {
            data[field] = this[field];
        });

        return data;
    }

    post(api, customData) {
        return this.submit('post', api, customData)
    }

    patch(api, customData) {
        return this.submit('patch', api, customData)
    }

    submit(requestType, api, customData) {
        this.isProcessing = true;

        const payload = _.assign({}, this.getFormData(), customData);

        return new Promise((resolve, reject) => {
            this.axios[requestType](api, payload)
                .then(response => {
                    resolve(response);
                })
                .catch(({ response }) => {
                    reject(response);
                })
                .done(_ => {
                    this.isProcessing = false;
                })
        });
    }
}